export const SET_RISK_TAB_STATUS = 'SET_RISK_TAB_STATUS' // tab状态
export const SET_SHOW_VIDEO = 'SET_SHOW_VIDEO' // 是否显示视频
export const SET_CLOSE_VIDEO = 'SET_CLOSE_VIDEO' // 关闭弹框
export const SET_QUICK_SEARCH = 'SET_QUICK_SEARCH' // 关闭弹框
